export default $wire => ({
    images: $wire.entangle('switcherImages').live,
    currentImage: $wire.entangle('currentImage').live,
    currentIndex: 0,
    totalImages: 0,

    init() {
        this.totalImages = this.images.length;
        // Initialize with first image
        this.currentImage = this.images[0];
        console.log(this.images.length);
    },

    switchFeatureImage(index) {
        if (index === 'prev') {
            this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
            this.currentImage = this.images[this.currentIndex];
            return;
        }

        if (index === 'next') {
            this.currentIndex = (this.currentIndex + 1) % this.images.length;
            this.currentImage = this.images[this.currentIndex];
            return;
        }

        // Handle numeric index clicks for thumbnails
        this.currentIndex = index;
        this.currentImage = this.images[index];
    },
});
